export default __webpack_public_path__ + "static/media/Animals-11.d8c86d88.png";